// node_modules
import { FC, useContext, useEffect, useState } from "react";
// Components
import { DivDropdown } from "Components";
// Types
import { TSavedQueryTempDTO, TTechnology } from "Types";
// styles
import styles from "./savedQueries.module.scss";
// Constants
import { TechnologyConstants } from "Constants";
// Contexts
import { SavedQueryContext } from "Providers";

type TSavedQueriesProps = {
    technologies: TTechnology[],
    selectedTechnology: TTechnology | undefined,
    handleSelectedTechnologyChange: (newTechnology: TTechnology | undefined) => void,
    caseQueryCount: number,
    isLoading: boolean
};

export const SavedQueries: FC<TSavedQueriesProps> = ({ technologies, selectedTechnology,
        handleSelectedTechnologyChange, caseQueryCount, isLoading }: TSavedQueriesProps) => {
    // Contexts
    const { savedQuery, updateSavedQuery } = useContext(SavedQueryContext);

    // State
    const [savedQueries, setSavedQueries] = useState<TSavedQueryTempDTO[]>([]);
    const [technologyList, setTechnologyList] = useState<TTechnology[]>([]);
    const [selectedTechnologyIndex, setSelectedTechnologyIndex] = useState<number>(0);

    // Logic
    useEffect(() => {
        const newTechnologyList = [...technologies];

        if (newTechnologyList.filter(technology =>
                technology.id === TechnologyConstants.GENERAL_TECHNOLOGY_ID &&
                technology.name.toLowerCase() === TechnologyConstants.GENERAL_TECHNOLOGY_NAME.toLowerCase()).length <= 0) {
            const generalTechnology: TTechnology = {
                id: TechnologyConstants.GENERAL_TECHNOLOGY_ID,
                name: TechnologyConstants.GENERAL_TECHNOLOGY_NAME,
                sideNotes: [],
                queryCount: caseQueryCount,
                isUserAdded: false
            };
            newTechnologyList.unshift(generalTechnology);
        }

        for (const technology of newTechnologyList) {
            if(technology.id === TechnologyConstants.GENERAL_TECHNOLOGY_ID &&
                    technology.name.toLowerCase() === TechnologyConstants.GENERAL_TECHNOLOGY_NAME.toLowerCase() &&
                    technology.queryCount !== caseQueryCount) {
                technology.queryCount = caseQueryCount;
            }
        }

        setTechnologyList([...newTechnologyList]);
    }, [caseQueryCount, technologies, technologies.length]);

    useEffect(() => {
        if (selectedTechnology !== undefined) {
            let i = 0;
            for (const technology of technologyList) {
                if (technology.id === selectedTechnology.id) {
                    handleSelectedTechnologyChange(technology);
                    setSelectedTechnologyIndex(i);
                }
                i++;
            }
        } else {
            handleSelectedTechnologyChange(technologyList[0]);
        }
    }, [handleSelectedTechnologyChange, selectedTechnology, technologyList]);

    useEffect(() => {
        if (!savedQuery || !savedQueries || (savedQueries && savedQueries.length < 1)) {return;}

        let isNewSavedQueryInCurrentList = false;

        for (const savedQ of savedQueries) {
            if (savedQ.guid === savedQuery.guid) {
                isNewSavedQueryInCurrentList = true;
            }
        }

        if (!isNewSavedQueryInCurrentList) {
            setSavedQueries([...savedQueries, savedQuery]);
        }

    }, [savedQueries, savedQuery]);

    if (technologyList.length >= 1 || isLoading) {
        return (
            <div className={styles.savedQuerySelectionContainer}>
                <h5>Select result</h5>
                <DivDropdown objectList={technologyList} selectedObjectIndex={selectedTechnologyIndex} newObjectSelected={(selectedObject: any) => { 
                        const currentlySelectedTechnology = selectedObject as TTechnology;                         
                        updateSavedQuery(undefined);
                        handleSelectedTechnologyChange(currentlySelectedTechnology); 
                    }}>
                    {technologyList.map(t => {
                        return (
                            <div key={t.id} className={styles.selectableTechnologyDropdownElement} title={`${t.name}`}>
                                <span>{`${t.name}`}</span>
                                <span>{`${t.queryCount ? t.queryCount : 0} ${t.queryCount && t.queryCount !== 1 ? "queries" : "query"}`}</span>
                            </div>
                        );
                    })}
                </DivDropdown>
            </div>
        );
    } else {
        return (
            <h5>You do not have any saved technologies.</h5>
        );
    }
};
